import { WebsiteDomainDnsStatus } from '../professional';
import { validateEnumTranslations } from '../../safety_checks';

export const TRANSLATE_KEY_WEBSITE_DOMAIN_DNS_STATUS = 'WEBSITE_DOMAIN_DNS_STATUS_';

export const WebsiteDomainDnsStatusTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_WEBSITE_DOMAIN_DNS_STATUS}${WebsiteDomainDnsStatus.NONE}`]: 'Non configuré',
    [`${TRANSLATE_KEY_WEBSITE_DOMAIN_DNS_STATUS}${WebsiteDomainDnsStatus.ASKED}`]: 'Propagation en cours',
    [`${TRANSLATE_KEY_WEBSITE_DOMAIN_DNS_STATUS}${WebsiteDomainDnsStatus.DONE}`]: 'Configuré',
  },
};

//DONT TOUCH below this line
validateEnumTranslations(
  WebsiteDomainDnsStatus,
  WebsiteDomainDnsStatusTranslation,
  TRANSLATE_KEY_WEBSITE_DOMAIN_DNS_STATUS,
  true,
);
